/* caselier-world-map.js */
(function () {
  'use strict';

  function init(root) {
    var svgUrl  = root.dataset.svgUrl;
    var dataUrl = root.dataset.dataUrl;
    var mapWrap = root.querySelector('.wm-map-wrap');
    if (!mapWrap || !svgUrl) return;

    var pinEls = []; /* { dot, ring } pairs */
    var pinVbW = 2000;
    var PIN_PX = window.innerWidth <= 680 ? 3 : 5;
    var openDesktopModal = null; /* set after data loads */

    /* Fetch SVG and JSON data in parallel */
    Promise.all([
      fetch(svgUrl).then(function (r) { if (!r.ok) throw new Error('SVG fetch failed'); return r.text(); }),
      dataUrl ? fetch(dataUrl).then(function (r) { return r.ok ? r.json() : {}; }) : Promise.resolve({})
    ]).then(function (results) {
      var text    = results[0];
      var data    = results[1];

      var countryMap = {};
      (data.countries || []).forEach(function (c) {
        var code = (c.code || '').trim().toUpperCase();
        if (code) countryMap[code] = (c.name || code);
      });

      var pins = (data.pins || []).filter(function (p) {
        return !isNaN(parseFloat(p.lat)) && !isNaN(parseFloat(p.lng));
      }).map(function (p) {
        return {
          lat:         parseFloat(p.lat),
          lng:         parseFloat(p.lng),
          city:        p.city        || '',
          name:        p.name        || '',
          review:      p.review      || '',
          photo:       p.photo       || '',
          model:       p.model       || '',
          case_type:   p.case_type   || '',
          design_name: p.design_name || '',
          design_url:  p.design_url  || ''
        };
      });

      var parser = new DOMParser();
      var doc    = parser.parseFromString(text, 'image/svg+xml');
      var svgEl  = doc.querySelector('svg');
      if (!svgEl) throw new Error('No SVG element');
      return { svgEl: svgEl, countryMap: countryMap, pins: pins };
    }).then(function (payload) {
      var svgEl      = payload.svgEl;
      var countryMap = payload.countryMap;
      var pins       = payload.pins;

      /* Ensure viewBox exists */
      if (!svgEl.getAttribute('viewBox')) {
        var sw = svgEl.getAttribute('width')  || '2000';
        var sh = svgEl.getAttribute('height') || '1001';
        svgEl.setAttribute('viewBox', '0 0 ' + parseFloat(sw) + ' ' + parseFloat(sh));
      }
      svgEl.setAttribute('preserveAspectRatio', 'xMidYMid meet');

      /* Read aspect ratio, apply to container */
      var vb  = svgEl.getAttribute('viewBox').split(/[\s,]+/);
      var vbW = parseFloat(vb[2]) || 2000;
      var vbH = parseFloat(vb[3]) || 1001;
      mapWrap.style.aspectRatio = (vbW / vbH).toFixed(4);

      svgEl.removeAttribute('width');
      svgEl.removeAttribute('height');
      svgEl.style.cssText = 'width:100%;height:100%;display:block;';

      var loading = mapWrap.querySelector('.wm-loading');
      if (loading) loading.remove();
      mapWrap.appendChild(svgEl);

      /* Legend HTML — reused for both instances */
      var legendHTML =
        '<span class="wm-legend-swatch"></span><span class="wm-legend-label">Shipped to</span>' +
        '<span class="wm-legend-sep"></span>' +
        '<svg class="wm-legend-dot" viewBox="0 0 12 12" width="10" height="10"><circle cx="6" cy="6" r="5" fill="#c9a84c"/></svg>' +
        '<span class="wm-legend-label">Review</span>';

      /* Desktop: top-right inside map */
      var legend = document.createElement('div');
      legend.className = 'wm-legend wm-legend--map';
      legend.innerHTML = legendHTML;
      mapWrap.appendChild(legend);

      /* Mobile: sits between subtitle and map in the flex column */
      var legendBelow = document.createElement('div');
      legendBelow.className = 'wm-legend wm-legend--below';
      legendBelow.innerHTML = legendHTML;
      var wmText = root.querySelector('.wm-text');
      if (wmText && wmText.parentNode) {
        wmText.parentNode.insertBefore(legendBelow, mapWrap);
      }

      applyCountries(svgEl, countryMap);
      applyPins(svgEl, pins, mapWrap, vbW, vbH);
      setupTooltip(svgEl, mapWrap);
      setupZoom(svgEl, mapWrap);
      scheduleReveal(svgEl, mapWrap);
      if (window.innerWidth > 680) {
        openDesktopModal = setupDesktopModal();
        setupCycle(mapWrap, svgEl, vbW, vbH);
      }
      setupReviewZone(root);
      window.addEventListener('resize', function () {
        PIN_PX = window.innerWidth <= 680 ? 3 : 5;
        updatePinRadii(scale);
      });
    }).catch(function () {
      var loading = mapWrap.querySelector('.wm-loading');
      if (loading) loading.textContent = 'Map unavailable';
    });

    /* ---- Country highlighting ---- */
    function applyCountries(svgEl, codeMap) {
      Object.keys(codeMap).forEach(function (code) {
        var name = codeMap[code];

        /* Custom SVG: data-iso="XX" — multiple paths per country */
        var byIso = svgEl.querySelectorAll('[data-iso="' + code + '"]');
        if (byIso.length) {
          byIso.forEach(function (el) {
            el.classList.add('wm-lit');
            el.dataset.countryName = name;
          });
          return;
        }

        /* Fallback: id-based SVGs (simplemaps etc.) */
        var el = svgEl.querySelector('#' + code) ||
                 svgEl.querySelector('#' + code.toLowerCase()) ||
                 svgEl.querySelector('[data-id="' + code + '"]');
        if (!el) return;

        if (el.tagName.toLowerCase() === 'g') {
          el.querySelectorAll('path, polygon').forEach(function (child) {
            child.classList.add('wm-lit');
            child.dataset.countryName = name;
          });
        } else {
          el.classList.add('wm-lit');
          el.dataset.countryName = name;
        }
      });
    }

    /* ---- Hover tooltip on lit countries ---- */
    var tooltip = document.createElement('div');
    tooltip.className = 'wm-tooltip';
    tooltip.hidden = true;
    mapWrap.appendChild(tooltip);

    function setupTooltip(svgEl, mapWrap) {
      svgEl.addEventListener('mousemove', function (e) {
        var target = e.target.closest ? e.target.closest('.wm-lit') : null;
        /* Fallback for SVG elements that don't support closest */
        if (!target && e.target.classList && e.target.classList.contains('wm-lit')) {
          target = e.target;
        }
        if (!target) { tooltip.hidden = true; return; }

        var name = target.dataset.countryName || '';
        if (!name) { tooltip.hidden = true; return; }

        tooltip.textContent = name;
        tooltip.hidden = false;

        var rect = mapWrap.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        var tw = tooltip.offsetWidth;
        var th = tooltip.offsetHeight;

        tooltip.style.left = Math.min(x + 12, rect.width  - tw - 8) + 'px';
        tooltip.style.top  = Math.max(y - th - 10, 6) + 'px';
      });

      svgEl.addEventListener('mouseleave', function () {
        tooltip.hidden = true;
      });
    }

    /* ---- Zoom & pan ---- */
    function setupZoom(svgEl, mapWrap) {
      var scale = 1;
      var tx = 0, ty = 0;
      var MIN_SCALE = 1, MAX_SCALE = 12;
      var SCROLL_FACTOR = 1.45; /* zoom amount per scroll step */

      /* Smooth animation state */
      var targetScale = 1, targetTx = 0, targetTy = 0;
      var animFrame = null;

      function clamp(val, min, max) { return Math.max(min, Math.min(max, val)); }

      function clampTranslate(s, x, y) {
        var maxTx = (s - 1) * mapWrap.offsetWidth  / 2;
        var maxTy = (s - 1) * mapWrap.offsetHeight / 2;
        return { x: clamp(x, -maxTx, maxTx), y: clamp(y, -maxTy, maxTy) };
      }

      function applyTransform() {
        var c = clampTranslate(scale, tx, ty);
        tx = c.x; ty = c.y;
        svgEl.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
        svgEl.style.transformOrigin = '50% 50%';
        mapWrap.style.cursor = dragging ? 'grabbing' : 'default';
        updateButtons();
        updatePinRadii(scale);
        if (positionBubbleFn) positionBubbleFn();
      }

      function lerp(a, b, t) { return a + (b - a) * t; }

      function animate() {
        var ease = 0.12;
        scale  = lerp(scale,  targetScale, ease);
        tx     = lerp(tx,     targetTx,    ease);
        ty     = lerp(ty,     targetTy,    ease);

        /* Clamp target too so pan doesn't drift outside bounds */
        var c = clampTranslate(targetScale, targetTx, targetTy);
        targetTx = c.x; targetTy = c.y;

        applyTransform();

        var done = Math.abs(scale - targetScale) < 0.001 &&
                   Math.abs(tx - targetTx) < 0.1 &&
                   Math.abs(ty - targetTy) < 0.1;
        if (!done) {
          animFrame = requestAnimationFrame(animate);
        } else {
          scale = targetScale; tx = targetTx; ty = targetTy;
          applyTransform();
          animFrame = null;
        }
      }

      function startAnim() {
        if (animFrame) return;
        animFrame = requestAnimationFrame(animate);
      }

      function zoomTo(newScale, pivotX, pivotY) {
        /* pivotX/Y are offsets from map centre in pixels */
        newScale = clamp(newScale, MIN_SCALE, MAX_SCALE);
        targetTx = pivotX - (pivotX - targetTx) * (newScale / targetScale);
        targetTy = pivotY - (pivotY - targetTy) * (newScale / targetScale);
        targetScale = newScale;
        startAnim();
      }

      /* Scroll wheel */
      mapWrap.addEventListener('wheel', function (e) {
        e.preventDefault();
        var factor = e.deltaY < 0 ? SCROLL_FACTOR : 1 / SCROLL_FACTOR;
        var rect = mapWrap.getBoundingClientRect();
        var cx = e.clientX - rect.left - mapWrap.offsetWidth  / 2;
        var cy = e.clientY - rect.top  - mapWrap.offsetHeight / 2;
        zoomTo(targetScale * factor, cx, cy);
      }, { passive: false });

      /* Drag pan */
      var dragging = false, dragStartX, dragStartY, dragTx, dragTy;
      mapWrap.addEventListener('mousedown', function (e) {
        if (scale <= 1) return;
        dragging = true;
        dragStartX = e.clientX; dragStartY = e.clientY;
        dragTx = targetTx; dragTy = targetTy;
        mapWrap.style.cursor = 'grabbing';
        if (animFrame) { cancelAnimationFrame(animFrame); animFrame = null; }
        e.preventDefault();
      });
      window.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        targetTx = dragTx + (e.clientX - dragStartX);
        targetTy = dragTy + (e.clientY - dragStartY);
        var c = clampTranslate(targetScale, targetTx, targetTy);
        targetTx = c.x; targetTy = c.y;
        tx = targetTx; ty = targetTy;
        applyTransform();
      });
      window.addEventListener('mouseup', function () {
        if (!dragging) return;
        dragging = false;
        mapWrap.style.cursor = 'default';
      });

      /* Touch — single finger pan + two finger pinch zoom */
      var lastPinchDist = null;
      var touchStartX, touchStartY, touchTx, touchTy;

      mapWrap.addEventListener('touchstart', function (e) {
        if (e.touches.length === 2) {
          lastPinchDist = pinchDist(e.touches);
        } else if (e.touches.length === 1 && targetScale > 1) {
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
          touchTx = targetTx;
          touchTy = targetTy;
          if (animFrame) { cancelAnimationFrame(animFrame); animFrame = null; }
        }
      }, { passive: true });

      mapWrap.addEventListener('touchmove', function (e) {
        if (e.touches.length === 2 && lastPinchDist !== null) {
          e.preventDefault();
          var dist = pinchDist(e.touches);
          targetScale = clamp(targetScale * (dist / lastPinchDist), MIN_SCALE, MAX_SCALE);
          scale = targetScale; tx = targetTx; ty = targetTy;
          lastPinchDist = dist;
          applyTransform();
        } else if (e.touches.length === 1 && touchStartX !== undefined && targetScale > 1) {
          e.preventDefault();
          targetTx = touchTx + (e.touches[0].clientX - touchStartX);
          targetTy = touchTy + (e.touches[0].clientY - touchStartY);
          var c = clampTranslate(targetScale, targetTx, targetTy);
          targetTx = c.x; targetTy = c.y;
          tx = targetTx; ty = targetTy;
          applyTransform();
        }
      }, { passive: false });

      mapWrap.addEventListener('touchend', function () {
        lastPinchDist = null;
        touchStartX = undefined;
      });

      /* Double-click reset */
      mapWrap.addEventListener('dblclick', function () {
        targetScale = 1; targetTx = 0; targetTy = 0;
        startAnim();
      });

      function pinchDist(touches) {
        var dx = touches[0].clientX - touches[1].clientX;
        var dy = touches[0].clientY - touches[1].clientY;
        return Math.sqrt(dx * dx + dy * dy);
      }

      /* ---- Zoom buttons ---- */
      var btnBar = document.createElement('div');
      btnBar.className = 'wm-zoom-bar';
      btnBar.innerHTML =
        '<button class="wm-zoom-btn" data-action="in"  aria-label="Zoom in">+</button>' +
        '<button class="wm-zoom-btn" data-action="out" aria-label="Zoom out">\u2212</button>' +
        '<button class="wm-zoom-btn wm-zoom-home" data-action="home" aria-label="Reset view">' +
          '<svg viewBox="0 0 16 16" fill="currentColor" width="13" height="13">' +
            '<path d="M8 1L1 7h2v7h4v-4h2v4h4V7h2L8 1z"/>' +
          '</svg>' +
        '</button>';

      /* Pin toggle bar — sits to the right of the zoom bar */
      var pinBar = document.createElement('div');
      pinBar.className = 'wm-pin-bar';
      pinBar.innerHTML =
        '<button class="wm-zoom-btn wm-pin-toggle" data-action="pins" aria-label="Toggle pins">' +
          '<svg viewBox="0 0 16 16" fill="currentColor" width="13" height="13" style="display:block;margin:auto;position:relative;top:1px">' +
            '<path d="M8 1a3.5 3.5 0 0 1 3.5 3.5c0 2.5-3.5 7.5-3.5 7.5S4.5 7 4.5 4.5A3.5 3.5 0 0 1 8 1zm0 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z"/>' +
          '</svg>' +
        '</button>';
      mapWrap.appendChild(btnBar);
      mapWrap.appendChild(pinBar);

      function updateButtons() {
        var homeBtn = btnBar.querySelector('[data-action="home"]');
        homeBtn.style.opacity = (targetScale > 1.05) ? '1' : '0.3';
        homeBtn.style.pointerEvents = (targetScale > 1.05) ? 'auto' : 'none';
      }
      updateButtons();

      /* Pin toggle */
      var pinsVisible = true;
      var pinToggleBtn = pinBar.querySelector('[data-action="pins"]');
      pinBar.addEventListener('click', function () {
        pinsVisible = !pinsVisible;
        var pinEls = Array.from(svgEl.querySelectorAll('.wm-pin-dot, .wm-pin-ring'));
        if (!pinsVisible) {
          var bubbleEl = mapWrap.querySelector('.wm-bubble');
          if (bubbleEl) {
            bubbleEl.classList.remove('wm-bubble--in');
            bubbleEl.classList.add('wm-bubble--out');
          }
          pinEls.forEach(function (el) {
            el.style.transition = 'none';
            el.style.opacity = '0';
            el.style.animation = 'none';
          });
          pinToggleBtn.style.opacity = '0.35';
        } else {
          pinEls.forEach(function (el, i) {
            el.style.transition = '';
            el.style.opacity = '';
            el.style.animation = '';
            el.classList.remove('wm-pin--in');
            /* Force reflow so animation restarts */
            void el.offsetWidth;
            el.style.animationDelay = (Math.floor(i / 2) * 150) + 'ms';
            el.classList.add('wm-pin--in');
          });
          pinToggleBtn.style.opacity = '';
        }
      });

      btnBar.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-action]');
        if (!btn) return;
        var action = btn.dataset.action;
        if (action === 'in') {
          zoomTo(targetScale * SCROLL_FACTOR, 0, 0);
        } else if (action === 'out') {
          zoomTo(targetScale / SCROLL_FACTOR, 0, 0);
        } else if (action === 'home') {
          targetScale = 1; targetTx = 0; targetTy = 0;
          startAnim();
        }
      });
      btnBar.addEventListener('dblclick', function (e) { e.stopPropagation(); });
      pinBar.addEventListener('dblclick', function (e) { e.stopPropagation(); });
    }

    /* ---- Scroll-triggered reveal ---- */
    function scheduleReveal(svgEl, target) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          /* Stagger country highlights */
          Array.from(svgEl.querySelectorAll('.wm-lit')).forEach(function (el, i) {
            el.style.animationDelay = (i * 80) + 'ms';
            el.classList.add('wm-animate');
          });
          /* Drop pins in after countries finish */
          var litCount = svgEl.querySelectorAll('.wm-lit').length;
          var baseDelay = litCount * 80 + 200;
          Array.from(svgEl.querySelectorAll('.wm-pin-dot, .wm-pin-ring')).forEach(function (el, i) {
            el.style.animationDelay = (baseDelay + Math.floor(i / 2) * 150) + 'ms';
            el.classList.add('wm-pin--in');
          });
        });
      }, { threshold: 0.15 });
      observer.observe(target);
    }

    /* ---- Pins ---- */
    /*
     * Web Mercator (EPSG:3857) pin placement.
     * The SVG was generated from 3857 data with bounding box injected below.
     * x: linear mapping of longitude via 3857 x = lng * 20037508.34 / 180
     * y: Mercator formula, then normalised to SVG space (y flipped).
     *
     * These constants must match the bounding box printed by geojson_to_svg.py.
     */
    var WM_X_MIN = -20037508.34;
    var WM_X_MAX =  20037508.34;
    var WM_Y_MIN = -7558416;    /* lat_to_3857(-56°S) */
    var WM_Y_MAX =  11753185;   /* lat_to_3857(72°N)  */
    var WM_SPAN_X = WM_X_MAX - WM_X_MIN;
    var WM_SPAN_Y = WM_Y_MAX - WM_Y_MIN;

    function latLngToSvg(lat, lng, vbW, vbH) {
      /* 3857 x */
      var mx = lng * 20037508.34 / 180;
      /* 3857 y (Mercator) */
      var lat_rad = lat * Math.PI / 180;
      var my = Math.log(Math.tan(Math.PI / 4 + lat_rad / 2)) * 6378137;
      /* Normalise to SVG space, flip y */
      return {
        x: (mx - WM_X_MIN) / WM_SPAN_X * vbW,
        y: (1 - (my - WM_Y_MIN) / WM_SPAN_Y) * vbH
      };
    }

    function pinR(scale) {
      return PIN_PX * pinVbW / (scale * mapWrap.offsetWidth);
    }

    function updatePinRadii(scale) {
      var dotR = pinR(scale);
      pinEls.forEach(function (p) {
        p.dot.setAttribute('r', dotR);
      });
    }

    function applyPins(svgEl, pins, mapWrap, vbW, vbH) {
      if (!pins.length) return;
      pinVbW = vbW;

      pins.forEach(function (pin) {
        var pos = latLngToSvg(pin.lat, pin.lng, vbW, vbH);
        var cx = pos.x;
        var cy = pos.y;
        var r0 = pinR(1);

        /* Ring */
        var ring = makeSvgEl('circle');
        ring.setAttribute('cx', cx);
        ring.setAttribute('cy', cy);
        ring.setAttribute('r', r0);
        ring.classList.add('wm-pin-ring');
        if (window.innerWidth <= 680) ring.style.display = 'none';

        /* Dot */
        var dot = makeSvgEl('circle');
        dot.setAttribute('cx', cx);
        dot.setAttribute('cy', cy);
        dot.setAttribute('r', r0);
        dot.classList.add('wm-pin-dot');

        pinEls.push({ dot: dot, ring: ring, cx: cx, cy: cy, pin: pin });

        svgEl.appendChild(ring);
        svgEl.appendChild(dot);

        dot.addEventListener('click', function (e) {
          e.stopPropagation();
          if (window.innerWidth > 680 && openDesktopModal) openDesktopModal(pin);
        });
        dot.addEventListener('touchend', function (e) {
          e.preventDefault();
          if (window.innerWidth > 680 && openDesktopModal) openDesktopModal(pin);
        });
      });
    }

    /* ---- Hover bubble ---- */
    var positionBubbleFn = null; /* called from applyTransform */

    function setupCycle(mapWrap, svgEl, vbW, vbH) {
      if (pinEls.length < 1) return;

      var bubble = document.createElement('div');
      bubble.className = 'wm-bubble';
      mapWrap.appendChild(bubble);

      var currentPinIdx = -1;
      var hoveredPinIdx = -1;
      var leaveTimer = null;
      var bubbleHovered = false;

      function svgToPixel(cx, cy) {
        var svgBCR  = svgEl.getBoundingClientRect();
        var wrapBCR = mapWrap.getBoundingClientRect();
        return {
          x: (svgBCR.left - wrapBCR.left) + cx * (svgBCR.width  / vbW),
          y: (svgBCR.top  - wrapBCR.top)  + cy * (svgBCR.height / vbH)
        };
      }

      function positionBubble(p) {
        var px = svgToPixel(p.cx, p.cy);
        var bubbleH = bubble.offsetHeight || 40;
        var above = px.y > bubbleH + 14;
        bubble.style.left = px.x + 'px';
        bubble.style.top  = px.y + 'px';
        if (above) {
          bubble.style.transform = 'translateX(-50%) translateY(calc(-100% - 10px))';
          bubble.classList.remove('wm-bubble--below');
        } else {
          bubble.style.transform = 'translateX(-50%) translateY(14px)';
          bubble.classList.add('wm-bubble--below');
        }
      }

      function showBubble(idx) {
        currentPinIdx = idx;
        var p = pinEls[idx];
        if (!p || (!p.pin.name && !p.pin.city)) return;
        var firstName = p.pin.name ? p.pin.name.split(' ')[0] : '';
        var city      = p.pin.city ? p.pin.city.split(',')[0] : '';
        bubble.innerHTML =
          (firstName ? '<span class="wm-bubble-name">' + esc(firstName) + '</span>' : '') +
          (city      ? '<span class="wm-bubble-city">' + esc(city)      + '</span>' : '') +
          '<span class="wm-bubble-cta">View more</span>';
        positionBubbleFn = function () { positionBubble(p); };
        positionBubbleFn();
        bubble.classList.remove('wm-bubble--out');
        bubble.classList.add('wm-bubble--in');
      }

      function hideBubble() {
        hoveredPinIdx = -1;
        bubble.classList.remove('wm-bubble--in');
        bubble.classList.add('wm-bubble--out');
        positionBubbleFn = null;
      }

      /* Click bubble to open modal */
      bubble.addEventListener('click', function (e) {
        e.stopPropagation();
        var p = pinEls[currentPinIdx];
        if (p && openDesktopModal) openDesktopModal(p.pin);
      });

      /* Hovering the bubble keeps it visible */
      bubble.addEventListener('mouseenter', function () {
        bubbleHovered = true;
        clearTimeout(leaveTimer);
        leaveTimer = null;
      });
      bubble.addEventListener('mouseleave', function () {
        bubbleHovered = false;
        hideBubble();
      });

      /* Dot hover via proximity on mousemove */
      mapWrap.addEventListener('mousemove', function (e) {
        var wrapBCR = mapWrap.getBoundingClientRect();
        var mx = e.clientX - wrapBCR.left;
        var my = e.clientY - wrapBCR.top;
        var hit = -1;
        pinEls.forEach(function (p, i) {
          var px = svgToPixel(p.cx, p.cy);
          var dx = mx - px.x, dy = my - px.y;
          if (Math.sqrt(dx*dx + dy*dy) < 12) hit = i;
        });
        if (hit !== -1 && hit !== hoveredPinIdx) {
          clearTimeout(leaveTimer);
          leaveTimer = null;
          hoveredPinIdx = hit;
          showBubble(hit);
        } else if (hit === -1 && hoveredPinIdx !== -1 && !bubbleHovered && leaveTimer === null) {
          leaveTimer = setTimeout(function () {
            leaveTimer = null;
            if (!bubbleHovered) hideBubble();
          }, 500);
        }
      });

      mapWrap.addEventListener('mouseleave', function () {
        clearTimeout(leaveTimer);
        leaveTimer = null;
        bubbleHovered = false;
        hideBubble();
      });
    }

    /* ---- Mobile review zone ---- */
    function setupReviewZone(root) {
      if (!pinEls.length) return;

      /* If the zone div isn't in the liquid yet, create it after the map */
      var zone = root.querySelector('.wm-review-zone');
      if (!zone) {
        zone = document.createElement('div');
        zone.className = 'wm-review-zone';
        zone.style.display = 'none';
        var wmContent = root.querySelector('.wm-content');
        var mapWrapEl = root.querySelector('.wm-map-wrap');
        if (mapWrapEl && mapWrapEl.parentNode) {
          mapWrapEl.parentNode.insertBefore(zone, mapWrapEl.nextSibling);
        } else if (wmContent) {
          wmContent.appendChild(zone);
        } else {
          return;
        }
      }

      /* Only show on mobile */
      if (window.innerWidth > 680) return;

      /* Filter pins that have enough content */
      var reviewPins = pinEls.filter(function (p) {
        return p.pin.name || p.pin.city || p.pin.review;
      });
      if (!reviewPins.length) return;

      zone.style.display = 'flex';

      /* Build structure */
      zone.innerHTML =
        '<div class="wm-rz-card">' +
          '<div class="wm-rz-body">' +
            '<div class="wm-rz-name"></div>' +
            '<div class="wm-rz-city"></div>' +
            '<div class="wm-rz-review"></div>' +
            '<div class="wm-rz-read-more">View more</div>' +
          '</div>' +
          '<img class="wm-rz-photo" src="" alt="" loading="lazy">' +
        '</div>' +
        '<div class="wm-rz-dots"></div>' +
        '<div class="wm-rz-modal" style="display:none">' +
          '<div class="wm-rz-modal-backdrop"></div>' +
          '<div class="wm-rz-modal-scroller">' +
            '<div class="wm-rz-modal-card">' +
              '<button class="wm-rz-modal-close" aria-label="Close">&times;</button>' +
              '<img class="wm-rz-modal-photo" src="" alt="">' +
              '<div class="wm-rz-modal-name"></div>' +
              '<div class="wm-rz-modal-city"></div>' +
              '<div class="wm-rz-modal-divider"></div>' +
              '<div class="wm-rz-modal-review"></div>' +
              '<div class="wm-rz-modal-divider"></div>' +
              '<div class="wm-rz-modal-meta"></div>' +
            '</div>' +
          '</div>' +
        '</div>';

      var card        = zone.querySelector('.wm-rz-card');
      var nameEl      = zone.querySelector('.wm-rz-name');
      var cityEl      = zone.querySelector('.wm-rz-city');
      var reviewEl    = zone.querySelector('.wm-rz-review');
      var photoEl     = zone.querySelector('.wm-rz-photo');
      var dotsWrap    = zone.querySelector('.wm-rz-dots');
      var modal       = zone.querySelector('.wm-rz-modal');
      var modalPhoto  = zone.querySelector('.wm-rz-modal-photo');
      var modalName   = zone.querySelector('.wm-rz-modal-name');
      var modalCity   = zone.querySelector('.wm-rz-modal-city');
      var modalReview = zone.querySelector('.wm-rz-modal-review');
      var modalScroller = zone.querySelector('.wm-rz-modal-scroller');
      var modalMeta     = zone.querySelector('.wm-rz-modal-meta');
      var modalClose    = zone.querySelector('.wm-rz-modal-close');

      /* Move modal to body so position:fixed is relative to viewport,
         not constrained by ancestor overflow:hidden on .wm-root */
      document.body.appendChild(modal);

      /* Build indicator dots */
      reviewPins.forEach(function (_, i) {
        var d = document.createElement('button');
        d.className = 'wm-rz-dot-btn';
        d.setAttribute('aria-label', 'Review ' + (i + 1));
        dotsWrap.appendChild(d);
      });
      var dotBtns = Array.from(dotsWrap.querySelectorAll('.wm-rz-dot-btn'));

      var activeIdx = 0;
      var cycleInterval = null;
      var manualOverride = false;
      var CYCLE_MS = 5000;

      /* Highlight the active SVG pin */
      function setActiveSvgPin(idx) {
        reviewPins.forEach(function (p, i) {
          var isActive = i === idx;
          p.dot.classList.toggle('wm-pin-dot--active', isActive);
          p.ring.style.display = isActive ? '' : 'none';
          p.ring.classList.toggle('wm-pin-ring--active', isActive);
        });
      }

      function showCard(idx, animate) {
        activeIdx = idx;
        var p = reviewPins[idx];

        /* Fade out then in if animating */
        if (animate) {
          card.classList.add('wm-rz-card--out');
          setTimeout(function () {
            fillCard(p);
            card.classList.remove('wm-rz-card--out');
            card.classList.add('wm-rz-card--in');
          }, 280);
        } else {
          fillCard(p);
          card.classList.add('wm-rz-card--in');
        }

        dotBtns.forEach(function (d, i) {
          d.classList.toggle('wm-rz-dot-btn--active', i === idx);
        });

        setActiveSvgPin(idx);
      }

      function fillCard(p) {
        nameEl.textContent   = p.pin.name   || '';
        cityEl.textContent   = p.pin.city   || '';
        reviewEl.textContent = p.pin.review ? '\u201c' + p.pin.review + '\u201d' : '';
        if (p.pin.photo) {
          photoEl.src = p.pin.photo;
          photoEl.style.display = '';
        } else {
          photoEl.style.display = 'none';
        }
      }

      function startCycle() {
        stopCycle();
        cycleInterval = setInterval(function () {
          if (manualOverride) return;
          showCard((activeIdx + 1) % reviewPins.length, true);
        }, CYCLE_MS);
      }

      function stopCycle() {
        clearInterval(cycleInterval);
        cycleInterval = null;
      }

      /* Dot indicator buttons */
      dotBtns.forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          manualOverride = true;
          stopCycle();
          showCard(i, true);
        });
      });

      /* Open / close review modal */
      function openModal(p) {
        if (p.pin.photo) {
          modalPhoto.src = p.pin.photo;
          modalPhoto.style.display = '';
        } else {
          modalPhoto.style.display = 'none';
        }
        modalName.textContent   = p.pin.name || '';
        modalCity.textContent   = p.pin.city || '';
        modalReview.textContent = p.pin.review ? '\u201c' + p.pin.review + '\u201d' : '';

        /* Meta rows: model, case type, design */
        var metaRows = [];
        if (p.pin.model)     metaRows.push(['Model',     p.pin.model,       '']);
        if (p.pin.case_type) metaRows.push(['Case Type', p.pin.case_type,   '']);
        if (p.pin.design_name) metaRows.push(['Design',  p.pin.design_name, p.pin.design_url || '']);
        modalMeta.innerHTML = metaRows.map(function (row) {
          var label = row[0], value = row[1], url = row[2];
          var valueHtml = url
            ? '<a href="' + url + '" class="wm-rz-modal-meta-link" target="_blank" rel="noopener">' + value + ' \u2197</a>'
            : '<span>' + value + '</span>';
          return '<div class="wm-rz-modal-meta-row"><span class="wm-rz-modal-meta-label">' + label + '</span>' + valueHtml + '</div>';
        }).join('');
        modalMeta.style.display = metaRows.length ? '' : 'none';

        modal.style.display = 'flex';
        modalScroller.scrollTop = 0;
      }

      function closeModal() {
        modal.style.display = 'none';
        modalPhoto.src = '';
      }

      modalClose.addEventListener('click', closeModal);
      modalScroller.addEventListener('click', function (e) {
        if (e.target === modalScroller) closeModal();
      });

      /* Swipe left/right on card to navigate; tap to open modal */
      var swipeStartX = null;
      var didSwipe = false;
      card.addEventListener('touchstart', function (e) {
        swipeStartX = e.touches[0].clientX;
        didSwipe = false;
      }, { passive: true });
      card.addEventListener('touchend', function (e) {
        if (swipeStartX === null) return;
        var dx = e.changedTouches[0].clientX - swipeStartX;
        swipeStartX = null;
        if (Math.abs(dx) >= 40) {
          didSwipe = true;
          manualOverride = true;
          stopCycle();
          var next = dx < 0
            ? (activeIdx + 1) % reviewPins.length
            : (activeIdx - 1 + reviewPins.length) % reviewPins.length;
          showCard(next, true);
        }
      }, { passive: true });

      /* Tap card (not swipe) opens modal */
      card.addEventListener('click', function () {
        if (didSwipe) { didSwipe = false; return; }
        openModal(reviewPins[activeIdx]);
      });

      /* Photo click also opens modal */
      photoEl.addEventListener('click', function (e) {
        e.stopPropagation();
        openModal(reviewPins[activeIdx]);
      });

      /* Also: tapping a map dot overrides to that pin */
      reviewPins.forEach(function (p, i) {
        p.dot.addEventListener('click', function () {
          manualOverride = true;
          stopCycle();
          showCard(i, true);
        });
        p.dot.addEventListener('touchend', function () {
          manualOverride = true;
          stopCycle();
          showCard(i, true);
        });
      });

      /* Init */
      showCard(0, false);
      startCycle();
    }

    function makeSvgEl(tag) {
      return document.createElementNS('http://www.w3.org/2000/svg', tag);
    }

    /* ---- Desktop modal ---- */
    function setupDesktopModal() {
      var dm = document.createElement('div');
      dm.className = 'wm-dm';
      dm.style.display = 'none';
      dm.innerHTML =
        '<div class="wm-dm-backdrop"></div>' +
        '<div class="wm-dm-scroller">' +
          '<div class="wm-dm-card">' +
            '<img class="wm-dm-photo" src="" alt="">' +
            '<div class="wm-dm-body">' +
              '<button class="wm-dm-close" aria-label="Close">&times;</button>' +
              '<div class="wm-dm-name"></div>' +
              '<div class="wm-dm-city"></div>' +
              '<div class="wm-dm-divider"></div>' +
              '<div class="wm-dm-review"></div>' +
              '<div class="wm-dm-divider"></div>' +
              '<div class="wm-dm-meta"></div>' +
            '</div>' +
          '</div>' +
        '</div>';
      document.body.appendChild(dm);

      var dmPhoto    = dm.querySelector('.wm-dm-photo');
      var dmName     = dm.querySelector('.wm-dm-name');
      var dmCity     = dm.querySelector('.wm-dm-city');
      var dmReview   = dm.querySelector('.wm-dm-review');
      var dmScroller = dm.querySelector('.wm-dm-scroller');
      var dmMeta     = dm.querySelector('.wm-dm-meta');
      var dmClose    = dm.querySelector('.wm-dm-close');

      function open(pin) {
        if (pin.photo) { dmPhoto.src = pin.photo; dmPhoto.style.display = ''; }
        else { dmPhoto.style.display = 'none'; }
        dmName.textContent   = pin.name   || '';
        dmCity.textContent   = pin.city   || '';
        dmReview.textContent = pin.review ? '\u201c' + pin.review + '\u201d' : '';

        var metaRows = [];
        if (pin.model)       metaRows.push(['Model',     pin.model,       '']);
        if (pin.case_type)   metaRows.push(['Case Type', pin.case_type,   '']);
        if (pin.design_name) metaRows.push(['Design',    pin.design_name, pin.design_url || '']);
        dmMeta.innerHTML = metaRows.map(function (row) {
          var label = row[0], value = row[1], url = row[2];
          var valueHtml = url
            ? '<a href="' + url + '" class="wm-dm-meta-link" target="_blank" rel="noopener">' + value + ' \u2197</a>'
            : '<span>' + value + '</span>';
          return '<div class="wm-dm-meta-row"><span class="wm-dm-meta-label">' + label + '</span>' + valueHtml + '</div>';
        }).join('');
        dmMeta.style.display = metaRows.length ? '' : 'none';

        dm.style.display = 'flex';
        dmScroller.scrollTop = 0;
      }

      function close() {
        dm.style.display = 'none';
        dmPhoto.src = '';
      }

      dmClose.addEventListener('click', close);
      dmScroller.addEventListener('click', function (e) {
        if (e.target === dmScroller) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
      });

      return open;
    }

    function esc(s) {
      return String(s || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }
  }

  document.querySelectorAll('.wm-root').forEach(init);
})();
